import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddAdminComponent } from './add-admin/add-admin.component';

@Component({
  selector: 'app-user-form-panel',
  templateUrl: './user-form-panel.component.html',
  styleUrls: ['./user-form-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, AddAdminComponent]
})
export class UserFormPanelComponent implements OnInit {
  @Input() accountId: string = '';
  @Input() canWrite: boolean = false;
  @Output() closePanel = new EventEmitter<void>();
  @Output() adminCreated = new EventEmitter<any>();

  @ViewChild(AddAdminComponent) addAdminForm?: AddAdminComponent;

  isVisible: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  open(): void {
    this.isVisible = true;
  }

  close(): void {
    this.isVisible = false;
    this.closePanel.emit();
  }

  onAdminCreated(adminData: any): void {
    this.adminCreated.emit(adminData);
    this.close();
  }

  onCancel(): void {
    this.close();
  }

  canSubmit(): boolean {
    return !!this.addAdminForm?.canSubmit();
  }

  submit(): void {
    this.addAdminForm?.submit();
  }
}
